import { getRoomPanelViewState } from '../selectors/getRoomPanelViewState';
import { mutatorAction } from 'satcheljs';
import { FeatureFilterItemType } from '../components/RoomFilter/FeatureFilterItemType';
import getRoomlistCapabilities from '../selectors/getRoomlistCapabilities';

export const increaseTotalNumSelectedCities = mutatorAction(
    'increaseTotalNumSelectedCities',
    (viewStateId: string | null) => {
        const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
        viewState.totalNumSelectedCities++;
    }
);

export const increaseTotalNumSelectedRoomLists = mutatorAction(
    'increaseTotalNumSelectedRoomLists',
    (viewStateId: string | null) => {
        const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
        viewState.totalNumSelectedRoomLists++;
    }
);

export const hasSelectedFromSuggestion = mutatorAction(
    'hasSelectedFromSuggestion',
    (viewStateId: string | null) => {
        const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
        viewState.selectedFromSuggestion = true;
    }
);

export const hasSelectedFromSearch = mutatorAction(
    'hasSelectedFromSearch',
    (viewStateId: string | null) => {
        const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
        viewState.selectedFromSearch = true;
    }
);

export const isFilterOpened = mutatorAction('isFilterOpened', (viewStateId: string | null) => {
    const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
    viewState.isFilterOpened = true;
});

export const isFilterApplied = mutatorAction('isFilterApplied', (viewStateId: string | null) => {
    const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
    const {
        selectedCapacity,
        selectedFeatures,
        selectedFloor,
        shouldGetSpaces,
    } = getRoomPanelViewState(viewStateId).roomFilterState;

    viewState.isFilterApplied = true;
    if (selectedCapacity) {
        viewState.isCapacityFilterApplied = true;
    }
    if (selectedFeatures) {
        viewState.isFeatureFilterApplied = true;
    }
    if (selectedFloor) {
        viewState.isFloorFilterApplied = true;
    }
    viewState.isWorkspaceBookingEnabled = shouldGetSpaces;
});

export const queryStringChanged = mutatorAction(
    'queryStringChanged',
    (viewStateId: string | null) => {
        const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
        viewState.queryStringChanged = true;
    }
);

export const updateCapabilitiesAvailability = mutatorAction(
    'updateCapabilitiesAvailability',
    (viewStateId: string | null) => {
        const roomListCapabilities = getRoomlistCapabilities(viewStateId);
        const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
        const hasFeatures = roomListCapabilities.hasFeatures;

        viewState.isCapacityEnabled =
            viewState.isCapacityEnabled || !!roomListCapabilities.maxCapacity;
        viewState.isFloorEnabled =
            viewState.isFloorEnabled || isFinite(roomListCapabilities.minFloor);
        viewState.isAudioEnabled =
            viewState.isAudioEnabled || hasFeatures[FeatureFilterItemType.Audio];
        viewState.isVideoEnabled =
            viewState.isVideoEnabled || hasFeatures[FeatureFilterItemType.Video];
        viewState.isDisplayEnabled =
            viewState.isDisplayEnabled || hasFeatures[FeatureFilterItemType.Display];
        viewState.isAccessibleEnabled =
            viewState.isAccessibleEnabled || hasFeatures[FeatureFilterItemType.Accessible];
    }
);

export const resetRoomPanelMetricsStore = mutatorAction(
    'resetRoomPanelMetricsStore',
    (viewStateId: string | null) => {
        const viewState = getRoomPanelViewState(viewStateId).roomPanelMetricsState;
        viewState.totalNumSelectedCities = 0;
        viewState.totalNumSelectedRoomLists = 0;
        viewState.selectedFromSuggestion = false;
        viewState.selectedFromSearch = false;
        viewState.isFilterOpened = false;
        viewState.isFilterApplied = false;
        viewState.isCapacityFilterApplied = false;
        viewState.isFeatureFilterApplied = false;
        viewState.isFloorFilterApplied = false;
        viewState.isCapacityEnabled = false;
        viewState.isAudioEnabled = false;
        viewState.isDisplayEnabled = false;
        viewState.isVideoEnabled = false;
        viewState.isAccessibleEnabled = false;
        viewState.isFloorEnabled = false;
    }
);
